import React from 'react'
import Profile from '../../components/profile'
import renderHTML from 'react-render-html'

export default class Indicator extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <>
        <div className='scrolly'>
          <div className='sticky'>
            <div className='ui two centered column grid stackable'>
              <div className='row introTitle'>
                {/* <div className='one wide column mobile hidden' /> */}
                <div className='ui column titleColumn'>
                  <div className='titleContainer'>
                    <h2 dangerouslySetInnerHTML={{__html: this.props.mainTitle}} />
                  </div>

                  <div className='subtitleContainer'>
                    <p dangerouslySetInnerHTML={{__html: this.props.subTitle}} />
                  </div>
                </div>
              </div>

              <div className='fifteen wide column'>
                <div className='ui equal width grid'>
                  <div className={`column tight today ${this.props.classRain}`}>
                    <div className='boxContainer'>
                      <div className='boxContent'>
                        <p className='boxPeriod'>
                          <span className={`boxStyleToday ${this.props.classRain}`}>Heute</span>
                        </p>
                        <p
                          className='boxPeriodDetail'
                          style={{ whiteSpace: 'nowrap' }}
                        >
                          (Ø 1981–2010)
                        </p>
                        <div className='boxCelsius'>
                          <h2>{this.props.valueToday}</h2>
                          <p className={`${this.props.classUnit}`}>{this.props.unitSection}</p>
                        </div>
                      </div>
                    </div>
                    <div className='arrowBox'>
                      <div className={`arrow-down ${this.props.classRain}`} />
                    </div>
                  </div>

                  <div className={`column tight c2060 shadow ${this.props.classRain}`}>
                    <div className='boxContainer'>
                      <div className='boxContent'>
                        <p className='boxPeriod'>
                          <span className={`boxStyle2060 ${this.props.classRain}`}>2060</span>
                        </p>
                        <p
                          className='boxPeriodDetail'
                          style={{ whiteSpace: 'nowrap' }}
                        >
                          (Ø 2045–2074)
                        </p>
                        <div className='boxCelsius'>
                          <h2>{this.props.value2060}</h2>
                          <p className={`${this.props.classUnit}`}>{this.props.unitSection}</p>
                        </div>
                        <div className={`boxProzent ${this.props.displayNonePercent}`}>
                            <p className='prozent'>({this.props.percent2060})</p>
                         </div>

                        <div className='boxClimate'>
                          <div className='iconWrapper mobile hidden'>
                            <i className='leaf icon' />{' '}
                            <span className='climateNr bold'>{this.props.valueClimate2060}</span>
                            <span className={`climateNr bold ${this.props.classSmall}`}>{this.props.unitSection}</span>
                          </div>

                          <div className='iconWrapper mobile only'>
                            <i className='leaf icon small' />{' '}
                            <span className='climateNr bold'>{this.props.valueClimate2060}</span>
                            <span className={`climateNr bold ${this.props.classSmall}`}>{this.props.unitSection}</span>
                          </div>

                          <p className='boxClimateDetail'>mit Klimaschutz</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={`column tight c2085 ${this.props.classRain}`}>
                    <div className='boxContainer'>
                      <div className='boxContent'>
                        <p className='boxPeriod'>
                          <span className={`boxStyle2085 ${this.props.classRain}`}>2085</span>
                        </p>
                        <p
                          className='boxPeriodDetail'
                          style={{ whiteSpace: 'nowrap' }}
                        >
                          (Ø 2070–2099)
                        </p>
                        <div className='boxCelsius'>
                          <h2>{this.props.value2085}</h2>
                          <p className={`${this.props.classUnit}`}>{this.props.unitSection}</p>
                        </div>

                        <div className={`boxProzent ${this.props.displayNonePercent}`}>
                            <p className='prozent'>({this.props.percent2085})</p>
                         </div>

                        <div className='boxClimate'>
                          <div className='iconWrapper mobile hidden'>
                            <i className='leaf icon' />{' '}
                            <span className='climateNr bold'>{this.props.valueClimate2085}</span>
                            <span className={`climateNr bold ${this.props.classSmall}`}>{this.props.unitSection}</span>
                          </div>

                          <div className='iconWrapper mobile only'>
                            <i className='leaf icon small' />{' '}
                            <span className='climateNr bold'>{this.props.valueClimate2085}</span>
                            <span className={`climateNr bold ${this.props.classSmall}`}>{this.props.unitSection}</span>
                          </div>

                          <p className='boxClimateDetail'>mit Klimaschutz</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='row stackable'>
                {/* <div className='one wide column mobile hidden' /> */}
                <div
                  className='five wide column tight textWrapper'
                  style={{ padding: '0 !important' }}
                >
                  <div className='textContainer'>
                    <div>
                      <p className={`${this.props.classRain}`} dangerouslySetInnerHTML={{__html: this.props.textIndicator}} />
                    </div>
                  </div>
                </div>
                <div className='ten wide column mobile hidden' />
              </div>
            </div>
          </div>

          <div className='step'>
            <div className='ui text container'>
              <Profile
                avatarSrc={require('../images/andreas-fischer.jpg')}
                name='Andreas Fischer'
                byline='MeteoSchweiz'
              >
                <div className='commentWrapper'>
                  <span
                  dangerouslySetInnerHTML={{__html: this.props.commentIndicator}}
                  />
                </div>
              </Profile>
            </div>
          </div>

          <div className='stepPuffer' />
        </div>
      </>
    )
  }
}
